import React from 'react';
import { Card, CardContent } from './ui/card';
import { mockStats, mockWhyChoose } from '../mock';
import { Award, Users, Globe, Calendar } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main About Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6">
              Who We Are
            </h2>
            <div className="space-y-4 text-gray-700 text-lg">
              <p>
                Shanghai RunTheRays International Trade Co., Ltd. is a professional international trade service provider specializing in sourcing, quality control, warehousing, and supply-chain management in China.
              </p>
              <p>
                Founded in 2019, we have helped businesses from Africa and over 25 countries worldwide navigate the complexities of the Chinese market with confidence.
              </p>
              <p className="font-semibold text-blue-900">
                We act as your trusted local partner in China, ensuring that every stage—from supplier selection to final shipment—meets your business goals, quality standards, and timelines.
              </p>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-lg shadow-lg p-8 mb-6">
              <h3 className="text-2xl font-bold text-blue-900 mb-4">Our Mission</h3>
              <p className="text-gray-700">
                To deliver seamless international trade solutions that empower global businesses to succeed in the Chinese marketplace through reliability, transparency, and operational excellence.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h3 className="text-2xl font-bold text-blue-900 mb-4">Our Vision</h3>
              <p className="text-gray-700">
                To become the most trusted and reliable sourcing, warehousing, and quality control partner for businesses trading with China worldwide.
              </p>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {mockStats.map((stat) => (
            <Card key={stat.id} className="text-center border-none shadow-lg bg-white hover:shadow-xl transition-shadow duration-300">
              <CardContent className="pt-8 pb-8">
                <div className="text-4xl md:text-5xl font-bold text-orange-600 mb-2">
                  {stat.value}
                </div>
                <div className="text-gray-600 font-semibold">{stat.label}</div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Why Choose Us */}
        <div className="bg-blue-900 rounded-2xl p-8 md:p-12 text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-8 text-center">
            Why Choose RunTheRays
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {mockWhyChoose.map((reason) => (
              <div key={reason} className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-orange-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <span className="text-white text-sm font-bold">✓</span>
                </div>
                <p className="text-lg">{reason}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;